/* c8 ignore start */
export const Regex = {
  uppercase: /[A-Z]/,
  lowcase: /[a-z]/,
  special_character: /\W|_/,
  number: /[0-9]/,
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

  "DD/MM/YYYY":
    /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/g,

  date_hour:
    /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))\s(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/,
  rg_mask: /^[0-9]{2}\.[0-9]{3}\.[0-9]{3}-[0-9]{1}$/,
  phone_mask: /^\(\d{2}\) \d{4,5}-\d{4}$/,
  cellphone_mask: /^\(\d{2}\) \d{5}-\d{4}$/,
  cep_mask: /^\d{2}\.\d{3}-\d{3}$/,
  cpf_mask: /^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}$/,
  cnpj_mask: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/,
  cpf_cnpj_mask: /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})$/,
  pis: /^\d{3}\.\d{5}\.\d{2}-\d$/,
  year: /^[0-9]{4}$/,
};
